export const ContactMethod = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  SMS: 'SMS',
};

export const ContactPersonType = {
  USER_CONTACT: 'User Contact',
  EMERGENCY_CONTACT: 'Emergency Contact',
  SYSTEM: 'System',
};

export const ContactTrigger = {
  AUTOMATION: 'Automation',
  INTERNAL_USER: 'Internal User',
  TRAILS_USER: 'Trails User',
  EMERGENCY_CONTACT: 'Emergency Contact',
};

export const ContactType = {
  CHECKOUT_REMINDER: 'Checkout reminder',
  CHECKOUT_ALERT: 'Checkout alert',
  EMERGENCY_CONTACT_ALERT: 'Emergency Contact Alert',
  USER_RESPONSE: 'User response',
  EMERGENCY_CONTACT_RESPONSE: 'Emergency Contact Response',
  OTHER: 'Other',
};

export const permissionAccess = [
  { key: 'write', value: 'Write' },
  { key: 'read', value: 'Read' },
  { key: 'admin', value: 'Admin' },
];

export const nameSortingOptions = [
  { key: 'asc', value: 'A to Z' },
  { key: 'desc', value: 'Z to A' },
];

export const dateSortingOptions = [
  { key: 'asc', value: 'Newest to Oldest' },
  { key: 'desc', value: 'Oldest to Newest' },
];

export const numberSortingOptions = [
  { key: 'asc', value: 'Smallest to Largest' },
  { key: 'desc', value: 'Largest to Smallest' },
];
